module.exports = __webpack_public_path__ + "static/media/menu-transfers.42d6b640.svg";